import { FormModal } from '../../Form'

function EntityProfileHeaderEditTitleModal({
  Component = FormModal,
  formTitle = 'Profile.EditTitleModalHeaderKey',
  ...restProps
}) {
  return <Component {...restProps} formTitle={formTitle} />
}

export default EntityProfileHeaderEditTitleModal
